export const CURREN_LANG = "Com.SCGC.PMM.Venus.Web.Int.current_lang";
